export default {
  apple: 'https://apps.apple.com/us/app/crisis-cleanup/id6463570192',
  android:
    'https://play.google.com/store/apps/details?id=com.crisiscleanup.prod',
};
